import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";

import { LoadingComponent, PageComponent, RefreshComponent, TableComponent } from "@shared/components";
import { HistoryRecord, HistoryResponse, HistoryTableData, RequestState } from "@shared/models";
import { GlobalService, HistoryApiService } from "@shared/services";
import { Observable, tap } from "rxjs";

@Component({
  selector: "app-history",
  standalone: true,
  imports: [PageComponent, RefreshComponent, TableComponent, CommonModule, LoadingComponent],
  templateUrl: "./history.component.html",
  styleUrl: "./history.component.scss",
})
export class HistoryComponent {
  globalService = inject(GlobalService);
  historyApiService = inject(HistoryApiService);

  historyData: HistoryResponse = {} as HistoryResponse;
  historyData$: Observable<RequestState<HistoryResponse>> = this.historyApiService.getHistory(false).pipe(
    tap((response) => {
      if (response.response) {
        this.historyData = response.response;
      }
    })
  );

  getBodyHeight(): string {
    return `calc(100vh - ${this.globalService.navbarHeight()}px - 180px)`;
  }

  refreshData(): void {
    this.historyData$ = this.historyApiService.getHistory(true);
  }

  updateHistory(record: HistoryRecord): void {
    this.historyData$ = this.historyApiService.updateHistoryRecord(record, this.historyData);
  }

  refreshHistoryRecord(id: number): void {
    this.historyData$ = this.historyApiService.getHistory(true, id);
  }
}
